import { Header } from '../../header/header.component';
import { MenuAcessibilidade } from '../../menu-acessibilidade';
import { MenuAvatar } from '../../menu-avatar/menu-avatar.component';
import MenuMobileAvatar from '../../menu-mobile-avatar/menu-mobile-avatar.component';
import S from '../app-container.styles';
import { AppHeaderProps } from '../app-container.types';
import { LeadContent } from './components/app-header-lead-content/app-header-lead-content.component';
import { AppHeaderLogo } from './components/app-header-logo/app-header-logo.component';
import { NonLeadContent } from './components/app-header-non-lead-content/app-header-non-lead-content.component';

export const AppHeader: React.FC<AppHeaderProps> = ({
  isLead,
  isDisciplinasHome,
  curso,
  listaCurso,
  tagSelecionada,
  setTagSelecionada,
  selecionarCurso,
  desktop,
  mobile,
  cursoSelecionadoLocal,
  tagPropsMapeadas,
  listaCursoFiltrada,
}) => {
  const parsedCurso = cursoSelecionadoLocal ? JSON.parse(cursoSelecionadoLocal) : null;

  const renderCenter = () => {
    if (isLead && isDisciplinasHome) {
      return (
        <LeadContent
          listaCurso={listaCurso}
          tagPropsMapeadas={tagPropsMapeadas}
          tagSelecionada={tagSelecionada}
          setTagSelecionada={setTagSelecionada}
          listaCursoFiltrada={listaCursoFiltrada}
          selecionarCurso={selecionarCurso}
        />
      );
    }
    if (!isLead && desktop) {
      return (
        <S.CursoWrapper>
          <NonLeadContent curso={curso} />
        </S.CursoWrapper>
      );
    }
    return null;
  };

  const renderAside = () => {
    if (desktop) {
      return (
        <S.HeaderAsideContainer>
          <MenuAcessibilidade dropdownPosition="bottom" />
          <MenuAvatar />
        </S.HeaderAsideContainer>
      );
    }
    if ((isLead && cursoSelecionadoLocal) || !isLead) {
      return <MenuMobileAvatar />;
    }
    return null;
  };

  return (
    <Header
      logo={<AppHeaderLogo mobile={mobile} isLead={isLead} parsedCurso={parsedCurso} curso={curso} />}
      center={renderCenter()}
      aside={renderAside()}
    />
  );
};
